module.exports = __webpack_public_path__ + "img/T6-A-rc_15.26380f17.png";